import { useFormik } from "formik";
import * as Yup from "yup";
import { Input, Button, DatePicker } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const CampaignLinkForm = ({ onSubmit, closeModal }) => {
  // ✅ Validation
  const validationSchema = Yup.object({
    programName: Yup.string().required("Program name is required"),
    academicYear: Yup.number()
      .required("Academic year is required")
      .min(2000, "Invalid year")
      .max(2100, "Invalid year"),
    dateRange: Yup.array()
      .of(Yup.date().required())
      .length(2, "Select a date range")
      .required("Date range is required"),
  });

  const formik = useFormik({
    initialValues: {
      programName: "",
      academicYear: "",
      dateRange: [],
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      const payload = {
        programName: values.programName,
        academicYear: values.academicYear,
        startDate: values.dateRange[0],
        endDate: values.dateRange[1],
        paymentDueDay: dayjs(values.dateRange[1]).diff(
          values.dateRange[0],
          "day",
        ),
      };

      console.log("Submitted:", payload);

      onSubmit?.(payload);
      resetForm();
    },
  });

  return (
    <div className="container py-3">
      <h5 className="mb-3">Créer un lien de campagne</h5>
      <p className="normal-text mt-1">
        Générez facilement un lien de campagne en un clic, partagez-le et
        recevez les frais de scolarité de vos élèves.
      </p>
      <form onSubmit={formik.handleSubmit}>
        {/* Program Name */}
        <div className="mb-2">
          <label className="form-label">Nom du programme</label>
          <Input
            name="programName"
            placeholder="Entrer le nom du programme ou libellé de la campagne"
            value={formik.values.programName}
            onChange={formik.handleChange}
          />
          {formik.touched.programName && formik.errors.programName && (
            <div className="text-danger small mt-1">
              {formik.errors.programName}
            </div>
          )}
        </div>

        {/* Academic Year */}
        <div className="mb-2">
          <label className="form-label">Année scolaire</label>
          <Input
            name="academicYear"
            type="number"
            placeholder="2026"
            value={formik.values.academicYear}
            onChange={formik.handleChange}
          />
          {formik.touched.academicYear && formik.errors.academicYear && (
            <div className="text-danger small mt-1">
              {formik.errors.academicYear}
            </div>
          )}
        </div>

        {/* Date Range */}
        <div className="mb-2">
          <label className="form-label">Date d'échéance du paiement</label>
          <RangePicker
            className="w-100"
            value={
              formik.values.dateRange.length === 2
                ? [
                    dayjs(formik.values.dateRange[0]),
                    dayjs(formik.values.dateRange[1]),
                  ]
                : null
            }
            onChange={(dates) => {
              formik.setFieldValue(
                "dateRange",
                dates ? [dates[0]?.toISOString(), dates[1]?.toISOString()] : [],
              );
            }}
          />
          {formik.touched.dateRange && formik.errors.dateRange && (
            <div className="text-danger small mt-1">
              {formik.errors.dateRange}
            </div>
          )}
        </div>

        {/* Buttons */}
        <div className="d-flex gap-3 mt-4">
          <Button type="primary" htmlType="submit">
            Créer le lien
          </Button>

          <Button htmlType="button" onClick={closeModal}>
            Annuler
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CampaignLinkForm;
